<script>
import EzButton from '@/components/ui/Button/EzButton';
import { COMMON as commonCy } from '@weareneopix/qa-utils/dist/orderEz/common';

/**
 *
 * @version 1.0.0
 * @since 2.4.0
 */
export default {
  components: {
    EzButton,
  },
  props: {
    disabled: {
      required: false,
      type: Boolean,
    },
    type: {
      required: false,
      type: String,
      default: 'primary',
    },
    isQuote: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPrimary() {
      return this.type === 'primary';
    },
  },
  data() {
    return {
      commonCy,
    };
  },
};
</script>
<template>
  <ez-button
    class="dropdown-actions__btn dropdown-actions__btn--complete"
    :disabled="disabled"
    :type="type"
    @click="$emit('actionClicked')"
    :data-cy="commonCy.SINGLE_ORDER.MANAGE_ORDER.BUTTON__CANCEL"
  >
    {{ isPrimary ? 'Cancel Order' : 'Cancel' }}
  </ez-button>
</template>
<style lang="scss" scoped></style>
